import {EventEmitter} from "@angular/core";
import { returnEmpty } from "@core/_utils/tools.utils";

export class HeaderAdminDelegate {
    id: number;
    name: string;
    desc: string;
    rightValues: string;
    notifyParent: EventEmitter<any> = new EventEmitter();

    public Clear() {
        this.id = 0;
        this.name = '';
        this.desc = '';
        this.rightValues = '';
    }

    public load(adata){
        this.id = adata.id;
        this.name = adata.name;
        this.desc = adata.description;
        this.rightValues = adata.rightValues;
        this.notifyParent.emit();
    }
}
